import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmiLookupService } from '@uygulamalar/hmi-pdks/pano/pages/personel/services/hmi-lookup.service';

@Component({
  selector: 'widget-uretim-verisi',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="uv-kapsayici">
      <div class="uv-baslik">
        <span class="uv-ikon">📊</span>
        <span class="uv-baslik-metni">Üretim Verileri</span>
      </div>
      @if (siparisler().length) {
        <div class="uv-istatistik">
          <div class="uv-huecre">
            <span class="uv-donur">{{ siparisler().length }}</span>
            <span class="uv-etiket">Aktif sipariş</span>
          </div>
          <div class="uv-huecre">
            <span class="uv-donur">{{ tamamlanan }}</span>
            <span class="uv-etiket">Tamamlanmış</span>
          </div>
        </div>
        <div class="uv-liste">
          @for (s of siparisler(); track s._id) {
            <div class="uv-satir">
              <span class="uv-siparis">{{ s.siparisNo }}</span>
              <span class="uv-urun">{{ s.urunAdi || '—' }}</span>
              <span class="uv-durum" [class]="durumSinifi(s.durum)">{{ durumMetni(s.durum) }}</span>
            </div>
          }
        </div>
      } @else {
        <div class="uv-boş">Üretim verisi yok</div>
      }
    </div>
  `,
  styles: [`
    :host { display: block; }
    .uv-kapsayici { font-family: var(--font-sistemi); }
    .uv-baslik { display: flex; align-items: center; gap: 8px; margin-bottom: 14px; }
    .uv-ikon { font-size: 18px; }
    .uv-baslik-metni { font-size: 15px; font-weight: 600; color: var(--py-metin); }
    .uv-istatistik { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 14px; }
    .uv-huecre { padding: 12px; border-radius: 12px; background: rgba(24,144,255,.08); text-align: center; }
    .uv-donur { display: block; font-size: 1.6em; font-weight: 800; color: #1890ff; font-variant-numeric: tabular-nums; }
    .uv-etiket { font-size: .75em; color: var(--py-metin-ikincil); }
    .uv-liste { display: flex; flex-direction: column; gap: 6px; }
    .uv-satir { display: flex; align-items: center; gap: 8px; padding: 9px 12px; border-radius: 8px; background: var(--py-arkaplan-kart); border: 1px solid var(--py-cekirdek-10); }
    .uv-siparis { font-size: 12px; font-weight: 700; color: var(--py-metin); }
    .uv-urun { font-size: 11px; color: var(--py-metin-ikincil); flex: 1; }
    .uv-durum { font-size: 10px; font-weight: 600; padding: 2px 8px; border-radius: 16px; }
    .uv-durum-siparis { background: rgba(250,173,20,.15); color: #faad14; }
    .uv-durum-üretildi { background: rgba(82,196,26,.15); color: #52c41a; }
    .uv-durum-tamamlandi { background: rgba(24,144,255,.15); color: #1890ff; }
    .uv-boş { font-size: 13px; color: var(--py-metin-gri); text-align: center; padding: 16px 0; }
  `]
})
export class WidgetUretimVerisiComponent implements OnInit {
  private lookup = inject(HmiLookupService);
  siparisler = signal<any[]>([]);
  tamamlanan = signal(0);

  ngOnInit(): void {
    this.lookup.siparisleriYukle().then((liste) => {
      this.siparisler.set(liste);
      this.tamamlanan.set(liste.filter(s => s.durum === 'tamamlandi' || s.durum === 'üretildi').length);
    });
  }

  durumKod(d: string | undefined): string {
    switch (d) {
      case 'üretildi': return 'üretildi';
      case 'tamamlandi': return 'tamamlandi';
      default: return 'siparis';
    }
  }

  durumSinifi(d: string | undefined): string {
    return `uv-durum-${this.durumKod(d)}`;
  }

  durumMetni(d: string | undefined): string {
    switch (this.durumKod(d)) {
      case 'üretildi': return 'Üretildi';
      case 'tamamlandi': return 'Tamamlandı';
      default: return 'Sipariş';
    }
  }
}
